import {AxiosResponse} from 'axios';
import axios from '@/core/tools/axios';
import { formatDateChoice } from '@/core';


import {Booking} from '../interfaces';

export default class BookingService {
  static createBooking(booking: Booking): Promise<AxiosResponse> {
    return axios.post('/booking/', booking);
  }

  static cancelBooking(id: string, userId : string): Promise<AxiosResponse> {
    return axios.delete(`/booking/${id}`, {
    params: {
      'userId' : userId
    }
  })
  }

  static getBooking(id: string): Promise<AxiosResponse> {
    return axios.get(`/booking/${id}`);
  }

  static getBookingList(email: string, userId : string): Promise<AxiosResponse> {    
    return axios.get(`/bookings/list`, {
      params: {
        'email' : email,
        'userId' : userId
      }
    });
  }

  static countBookings(customerId: string, date: string): Promise<AxiosResponse> {
    return axios.get(`/booking/count/${customerId}/${date}/`);
  }

  static dateRange(bookingList: any): string[]{
    
    if (bookingList.length){
      const minDate = formatDateChoice(bookingList[0].date, '{month-short} {day-short} {date}') 
      let maxDate = formatDateChoice(bookingList?.at(-1).date, '{month-short} {day-short} {date}')
      if (minDate.split(' ')[0] === maxDate.split(' ')[0]){
        
          maxDate = maxDate.split(' ').slice(1).join(' ')     
}
  return [minDate, maxDate]
    }
    return []
  }
}
